module.exports = __webpack_public_path__ + "static/media/apple-store.0888419e.png";